import { render, staticRenderFns } from "./FormModalMedical.vue?vue&type=template&id=70ad718c&scoped=true"
import script from "./FormModalMedical.vue?vue&type=script&lang=js"
export * from "./FormModalMedical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad718c",
  null
  
)

export default component.exports